module.exports = __webpack_public_path__ + "static/media/CTLA_5-383w.b9ab52f9.jpg";